import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';


import { ShFormMultiSelectModule } from '../form-multi-select/form-multi-select.module';

import { ShFormDateSelectComponent } from './form-date-select.component';

@NgModule({
    imports: [CommonModule, ReactiveFormsModule, ShFormMultiSelectModule, ShFormDateSelectComponent],
    exports: [ShFormDateSelectComponent]
})
export class ShFormDateSelectModule {}

export { ShFormDateSelectComponent } from './form-date-select.component';
